import SearchDropdownButton, { Props } from './SearchDropdownButton.component';

export default SearchDropdownButton;
export type { Props };
